import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfigurationSaisieDonneesAnalyse, ModeSaisie } from 'src/app/bo/configurationSaisieDonneesAnalyse';
import { ModifyKpiModalComponent } from '../modify-kpi-modal/modify-kpi-modal.component';
import { DonneeAnalyse } from 'src/app/bo/donneeAnalyse';
import { KpiService } from 'src/app/services/kpi.service';
import { SitesService } from 'src/app/services/sites.service';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { VibrationsRecordService } from '../../services/vibrations-record.service';


@Component({
  selector: 'app-grid-list-kpi',
  templateUrl: './grid-list-kpi.component.html',
  styleUrls: ['./grid-list-kpi.component.scss'],
  standalone: false
})
export class GridListComponentKpi implements OnInit {

  @Input() listeObjets: ConfigurationSaisieDonneesAnalyse[] = [];
  @Input() configeView = true;
  @Input() tabDonneesAnalyse: DonneeAnalyse[];
  @Input() estProjet = false;
  @Input() estTir = false;
  @Input() siteCurrency = '';
  @Input() inProjetDetail = false;
  @Input() tirId: number;
  currentSortColumn: string | null = null;
  currentSortDirection: 'asc' | 'desc' = 'asc';
  donneesAnalyse: DonneeAnalyse[];
  @Input() isGuest = false;
  tabModeSaisieProjet: any[] = [];

  isEditionMode: boolean[] = [];
  selectedKpiIndex = 0;
  editMode = false;

  currency = '';

  constructor(
    private readonly dialogConfirme: MatDialog,
    private readonly cdr: ChangeDetectorRef,
    private readonly kpiService: KpiService,
    private readonly siteService: SitesService,
    private readonly utilService: UtilisateurService,
    private readonly fonctionsService: FonctionsService,
    private readonly vibrationsRecordService: VibrationsRecordService
  ) {
    kpiService.getCalculModeSaisieProjet().subscribe(
      (tabModeSaisie) => {
        this.tabModeSaisieProjet = tabModeSaisie;
      });
  }

  getNomModeSaisie(val: number): string {
    const item = this.tabModeSaisieProjet.find(mode => mode.val === val);
    return item ? item.nom : ModeSaisie.Manuelle.toString();
  }


  ngOnInit(): void {
    this.syncOverpressureKpiIfNeeded();
    this.siteService.getSiteCosts(this.utilService.currentSite().siteId).subscribe({
      next: (siteCosts) => {
        if (siteCosts && siteCosts.length > 0) {
          this.currency = siteCosts[0].currency;
        }
      }
    });

    this.initKpiBlast();

    if (this.tabDonneesAnalyse) {
      this.tabDonneesAnalyse.forEach(() => {
        this.isEditionMode.push(false);
      });
    }
  }


  private syncOverpressureKpiIfNeeded(): void {
    if (!this.estTir || !this.tirId || !this.tabDonneesAnalyse) {
      return;
    }
    this.vibrationsRecordService
      .getBlastKpi(this.utilService.currentSite().siteId, this.tirId)
      .subscribe({
        next: (response) => {
          if (!response?.data?.length) {
            return;
          }
          const overpressureKpiData = response.data.find(
            (kpi) => kpi.name?.toLowerCase().includes('overpressure')
          );
          if (overpressureKpiData?.value == null) {
            return;
          }
          const overpressureDonnee = this.tabDonneesAnalyse.find(
            (donnee) =>
              donnee.referentielDonneeAnalyse?.nom
                ?.toLowerCase()
                .includes('air overpressure')
          );
          if (!overpressureDonnee) {
            return;
          }
          const incomingValue = this.formatValue(
            overpressureKpiData.value.toString()
          );
          const currentMeasured = overpressureDonnee.measuredValue
            ? this.formatValue(overpressureDonnee.measuredValue)
            : null;
          if (incomingValue !== currentMeasured) {
            overpressureDonnee.measuredValue = incomingValue;
            this.updateDonneeAnalyse(overpressureDonnee);
            this.initKpiBlast();
            this.cdr.detectChanges();
          }
        },
      });
  }

  protected initKpiBlast(): void {
    if (!this.configeView) {
      for (let i = 0; i < this.tabDonneesAnalyse.length; i++) {
        this.tabDonneesAnalyse[i] = this.setFinalValue(this.tabDonneesAnalyse[i]);
        const kpiBlast = this.tabDonneesAnalyse[i];
        this.setBlastKpi(kpiBlast);
      }

      this.donneesAnalyse = this.tabDonneesAnalyse.filter(donnee =>
        donnee.isEnabled === true && (this.isGuest ? donnee.accessPermission > 0 : true)
      );
    }
  }

  onRefresh(): void {
    if (this.estTir && this.tirId) {
      this.fonctionsService.loading_screen(true);
      this.kpiService.triggerKpiCalculation(this.tirId).subscribe({
        next: (response) => {
          if (this.tabDonneesAnalyse) {
            this.initKpiBlast();
            this.cdr.detectChanges();
          }
          this.fonctionsService.loading_screen(false);
          this.fonctionsService.launch_toast(true);
        },
        error: (error) => {
          this.fonctionsService.loading_screen(false);
          this.fonctionsService.launch_toast(false);
        }
      });
    }
  }

  protected setBlastKpi(kpiBlast: DonneeAnalyse): void {
    const newItem = this.listeObjets.find(newItem => newItem.referentielDonneeAnalyseId === kpiBlast.referentielDonneeAnalyseId);
    kpiBlast.referentielDonneeAnalyse.type = newItem.referentielDonneeAnalyse.type;
    kpiBlast.referentielDonneeAnalyse.description = newItem.referentielDonneeAnalyse.description;
    kpiBlast.referentielDonneeAnalyse.displayUnit = this.extractSymbol(newItem.displayUnit) || newItem.referentielDonneeAnalyse.nomUniteReferentiel;

    if (kpiBlast.valeur == '' || kpiBlast.valeur == null) {
      kpiBlast.valeur = newItem.valeurNominal?.toString();
      kpiBlast.sourceKpi = 'SOURCE_KPI.SITE';
    } else if (kpiBlast.valeur == newItem.valeurNominal?.toString()) {
      kpiBlast.sourceKpi = 'SOURCE_KPI.SITE';
    } else {
      if (this.estProjet) {
        kpiBlast.sourceKpi = 'SOURCE_KPI.PROJECT';
      }
      else {
        kpiBlast.sourceKpi = 'SOURCE_KPI.BLAST';
      }
    }
  }

  protected sortColumn(column: string): void {
    if (this.currentSortColumn === column) {
      this.currentSortDirection = this.currentSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSortColumn = column;
      this.currentSortDirection = 'asc';
    }
    this.sortKpis();
  }

  private sortKpis(): void {
    if (!this.currentSortColumn) {
      return;
    }
    const directionMultiplier = this.currentSortDirection === 'asc' ? 1 : -1;
    (this.configeView ? this.listeObjets : this.donneesAnalyse).sort((a, b) => {
      const aValue = this.extractValue(a, this.currentSortColumn!);
      const bValue = this.extractValue(b, this.currentSortColumn!);

      if (aValue > bValue) {
        return directionMultiplier;
      } else if (aValue < bValue) {
        return -directionMultiplier;
      } else {
        return 0;
      }
    });
  }

  private extractValue(kpi: ConfigurationSaisieDonneesAnalyse, column: string): any {
    switch (column) {
      case 'NOM':
        return kpi.referentielDonneeAnalyse.nom?.toLowerCase();
      case 'TYPE':
        return kpi.referentielDonneeAnalyse.type?.toLowerCase();
      case 'CALCUL_MODE':
        return kpi.referentielDonneeAnalyse.calculMode?.toLowerCase();
      case 'UNIT':
        return kpi.referentielDonneeAnalyse.nomUniteReferentiel?.toLowerCase();
      case 'ACCESS':
        return kpi.accessPermission;
      case 'ENABLED':
        return kpi.isEnabled;
      default:
        return '';
    }
  }

  protected setFinalValue(donnee: DonneeAnalyse): DonneeAnalyse {
    const valueSourceMapping = [
      { value: donnee.manualValue, source: 'SOURCE_KPI.MANUAL' },
      { value: donnee.measuredValue, source: 'SOURCE_KPI.MEASURED' },
      { value: donnee.designValue, source: 'SOURCE_KPI.DESIGN' }
    ];

    for (const { value, source } of valueSourceMapping) {
      if (value) {
        let finalValue = value;
        
        if (this.isAzimuth(donnee)) {
          finalValue = (Number(value) * 180 / Math.PI).toString();
          if(source === 'SOURCE_KPI.MANUAL')
          {
            donnee.manualValue = this.formatValue(finalValue);
          }
        }
        
        donnee.finalValue = this.formatValue(finalValue);
        donnee.sourceFinalValue = source;
        return donnee;
      }
    }

    donnee.finalValue = '';
    donnee.sourceFinalValue = 'SOURCE_KPI.NOT_SET';
    return donnee;
  }

  protected onModifyKpiConfig(idKpi: number) {
    let kpiBlast = this.tabDonneesAnalyse?.find(kpi => kpi.referentielDonneeAnalyseId === idKpi);
    let kipConfig = this.listeObjets.find(kpi => kpi.referentielDonneeAnalyseId === idKpi);
    const dialogRef = this.dialogConfirme.open(ModifyKpiModalComponent,
      {
        data: { kpiConfig: kipConfig, kpiBlast: kpiBlast, configView: this.configeView, isGuest: this.isGuest },
      },
    );

    dialogRef.afterClosed().subscribe(result => {
      if (result && !this.configeView) {
        this.initKpiBlast();
        this.cdr.detectChanges();
      }
    });
  }

  protected formatValue(value: string): string {
    const numericValue = parseFloat(value);

    if (isNaN(numericValue)) {
      return value;
    }

    return (Math.abs(numericValue) < 10
      ? +numericValue.toFixed(2)
      : +numericValue.toFixed(0)).toString();
  }

  private isAzimuth(donnee: DonneeAnalyse): boolean {
    const nom = donnee.referentielDonneeAnalyse?.nom?.toLowerCase() || '';
    return nom.includes('azimuth') || nom.includes('azimut');
  }


  onEditFinalValue(index: number): void {
    this.editMode = true
    this.isEditionMode[index] = !this.isEditionMode[index];
    this.selectedKpiIndex = index;
    if (this.tabDonneesAnalyse) {
      this.tabDonneesAnalyse.forEach((kpi, i) => {
        if (i !== index) {
          this.isEditionMode[i] = false;
        }
      });
    }
  }


  @ViewChild('inputContainer') inputContainer!: ElementRef;
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent): void {
    if (!this.configeView && !this.inputContainer?.nativeElement.contains(event.target) && !this.editMode) {
      this.tabDonneesAnalyse.forEach((kpi, i) => {
        this.isEditionMode[i] = false;
      });
    }
    this.editMode = false;
  }


  onValidate(index: number, kpi: DonneeAnalyse, isReset = false): void {
    this.isEditionMode[index] = !this.isEditionMode[index];
    this.selectedKpiIndex = index;
    this.toRadianAllKapiAzimuths(this.tabDonneesAnalyse);
    if (!isReset) {
      this.tabDonneesAnalyse[index].manualValue = this.formatValue(kpi.manualValue);
    } else {
      this.tabDonneesAnalyse[index].manualValue = '';
      kpi.manualValue = '';
    }
    this.updateDonneeAnalyse(kpi);

    this.initKpiBlast();
  }

  toRadianAllKapiAzimuths(kpi: DonneeAnalyse[]) {
    let listKpiAzimuth = kpi.filter(k => this.isAzimuth(k));
    for (let i = 0; i < listKpiAzimuth.length; i++) {
      listKpiAzimuth[i].manualValue = (Number(listKpiAzimuth[i].manualValue) * Math.PI / 180).toString();
    }
  }

  toAzimuthKpi(kpi: DonneeAnalyse, value : number) {
    if (this.isAzimuth(kpi)) {
      value = (Number(value) * 180 / Math.PI);
      return this.formatValue(value.toString());
    }
    return value;
  }


  protected updateDonneeAnalyse(updatedDonneeAnalyse: DonneeAnalyse): void {
    this.kpiService.updateDonneeAnalyse(updatedDonneeAnalyse).subscribe(
      response => {
        console.log('Donnee Analyse updated successfully:', response);
      },
      error => {
        console.error('Error updating Donnee Analyse:', error);
      }
    );
  }

  onCheckboxChange(event: Event, kpi: DonneeAnalyse): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      kpi.manualValue = 'Oui';
    } else {
      kpi.manualValue = 'Non';
    }
    this.updateDonneeAnalyse(kpi);
  }

  replaceCurrencyPlaceholder(currency: string): string {
    const finalCurrency = this.currency || '¤';
    return currency?.replace('CURRENCY', finalCurrency) ?? '';
  }

  extractSymbol(displayUnit: string): string | undefined {
    if (!displayUnit) return undefined;
    const parts = displayUnit.split(' - ');
    return parts.length > 1 ? parts[1].trim() : displayUnit;
  }

}

